import EventBus from '../../../../event-bus'
export function updateCalculatedProps(invoice_entry, header) {
    // في حال تغيير المستودع 
    // -- في حال وجود مادة سيتم حذف المادة
    // ---سيتم قدح حدث لتحديث قوائم المواد بناءً على المستودع المُختار
    // ---في حال لم يتم تعيين مستودع سيتم عرض جميع مواد الملف المالي
    if(header == 'warehouse_id')
    {
        EventBus.$emit('warehouse-changed', invoice_entry.warehouse_id)
    }
    // في حال تعيين مادة وما من مستودع مُختار سيتم تعيين المستودع التابع للمادة
    if(header == 'material_id')
    {
        if(!invoice_entry.warehouse_id && invoice_entry.material_id)
            EventBus.$emit('warehouse-changed', null, invoice_entry.material_id)
    }
    // في حال تغيير الكمية أو السعر
    // -- تحديث عمود القيمة 
    // -- تعديل قيمة الحسم
    if((header == 'quantity' && invoice_entry.price) || (header == 'price' && invoice_entry.quantity) )
    {
        let discount_amount = 0
        
        if(invoice_entry.discount_percentage)
        {
            invoice_entry.discount_amount = (invoice_entry.quantity * invoice_entry.price * invoice_entry.discount_percentage) / 100
            discount_amount = invoice_entry.discount_amount
        }

        if(invoice_entry.calculated_total_amount != invoice_entry.quantity * invoice_entry.price - discount_amount)
            invoice_entry.calculated_total_amount = invoice_entry.quantity * invoice_entry.price - discount_amount

    }
    // في حال تغيير عمود القيمة 
    // -- سيتم تحديث السعر
    if(header == 'calculated_total_amount' && invoice_entry.quantity && invoice_entry.price)
    {
        let discount_amount = 0
        if(invoice_entry.discount_amount) 
            discount_amount = invoice_entry.discount_amount
        
        if(invoice_entry.calculated_total_amount != invoice_entry.quantity * invoice_entry.price - discount_amount)
            invoice_entry.price = (invoice_entry.calculated_total_amount + discount_amount) / invoice_entry.quantity
    }

    // في حال تعيين نسبة حسم 
    // -- سيتم تحديث عمود القيمة 
    // -- سيتم تحديث عمود قيمة الحسم 
    if(header == 'discount_amount' && invoice_entry.calculated_total_amount)
    {
        let discount_amount = 0
        if(invoice_entry.discount_amount) 
        {
            discount_amount = invoice_entry.discount_amount

            if((invoice_entry.calculated_total_amount + discount_amount) != invoice_entry.price * invoice_entry.quantity)
            {
                invoice_entry.calculated_total_amount = (invoice_entry.quantity * invoice_entry.price) - invoice_entry.discount_amount
                invoice_entry.discount_percentage = (invoice_entry.discount_amount * 100) / (invoice_entry.quantity * invoice_entry.price)
            }
        }
        else{
            invoice_entry.discount_percentage = 0
            invoice_entry.calculated_total_amount = invoice_entry.quantity * invoice_entry.price 
        }
        
    }

    // في حال تعيين قيمة الحسم 
    //  -- سيتم تحديث عمود القيمة 
    //  -- سيتم تحديث نسبة الحسم 
    if(header == 'discount_percentage' && invoice_entry.calculated_total_amount)
    {
        if(invoice_entry.discount_percentage)
        {
            if(invoice_entry.discount_percentage != (invoice_entry.discount_amount * 100) / invoice_entry.calculated_total_amount)
            {
                invoice_entry.discount_amount = (invoice_entry.quantity * invoice_entry.price * invoice_entry.discount_percentage) / 100
                invoice_entry.calculated_total_amount = invoice_entry.quantity * invoice_entry.price - invoice_entry.discount_amount
            }
        }
        else{
            invoice_entry.discount_amount = null
            invoice_entry.calculated_total_amount = invoice_entry.quantity * invoice_entry.price 
        }
    }
}
import store from "../../../../store/index.js";
export function setLastPriceForMaterial(journal_entry, header){
    
    if(header == 'material_id' && journal_entry.material_id)
    {
        if(journal_entry.material_id)
            store.dispatch("materials/fetchLastPurchasePrice", journal_entry.material_id)
                .then(response=>{
                    journal_entry.price = { amount: response, currency_id: null }
                })
    }
}
import _ from 'lodash'
export function refactorRecord(invoice_entry, default_currency_id){
    var invoice_entry_template = {
        id: null,
        invoice_id: null,
        material_id: null,
        quantity: null,
        count: null,
        price: null,
        discount_percentage: 0,
        discount_amount: null,
        calculated_total_amount: null,
        notes: null,
        type: null
    }

    //lodash library
    //_.set(object, path, value)
    Object.entries(invoice_entry).forEach(([key, value]) => _.set(invoice_entry_template, key, value))
    
    invoice_entry_template.quantity = invoice_entry.quantity ? { quantity: invoice_entry.quantity, unit_size_id: null } : null
    invoice_entry_template.price = invoice_entry.price ? { amount: invoice_entry.price, currency_id: default_currency_id } : null
    invoice_entry_template.calculated_total_amount = invoice_entry.calculated_total_amount ? { amount: invoice_entry.calculated_total_amount, currency_id: default_currency_id } : null
    invoice_entry_template.discount_amount = invoice_entry.discount_amount ? { amount: invoice_entry.discount_amount, currency_id: default_currency_id } : { amount: 0, currency_id: default_currency_id }

    delete invoice_entry_template.warehouse_id
    delete invoice_entry_template.no
    return invoice_entry_template
}
